import { render } from "./AnonymousPageLayout.vue?vue&type=template&id=3022caa9"
import script from "./AnonymousPageLayout.vue?vue&type=script&lang=js"
export * from "./AnonymousPageLayout.vue?vue&type=script&lang=js"

import "./AnonymousPageLayout.vue?vue&type=style&index=0&id=3022caa9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__